/*
 * @Author: liyihui
 * @Date:
 * @description:  接口请求访问地址 关于我们
 * @Last Modified by:
 * @Last Modified time:
 */

import { gwManageGET, gwManagePOST, gwManagePUT, gwManageDEL } from './index';

// 公司简介查询
function getCompanyProfileList({}, func) {
	gwManageGET('queryCompanyIntroductionByClient', {}, func);
}
// 公司荣誉查询
function getCompanyHonorList({}, func) {
	gwManageGET('queryCompanyHonorByClient', {}, func);
}
// 发展战略查询
function getDevelopmentStrategyList({}, func) {
	gwManageGET('queryDevelopmentStrategyByClient', {}, func);
}
// 企业文化查询
function getCorporateCultureList(data, func) {
	gwManageGET('queryCompanyCultureListByClient', data, func);
}
// 技术专利查询
function getTechnologyPatentList({}, func) {
	gwManageGET('queryTechnologyPatentListByClient', {}, func);
}
// 发展历程查询
function getDevelopmentHistoryList(data, func) {
	gwManageGET('queryDevelopmentHistoryListByClient', data, func);
}
// 组织架构查询
function getOrganizationalStructureList(data, func) {
	gwManageGET('queryOrganizationByClient', data, func);
}

const API = {
	getCompanyProfileList,
	getCompanyHonorList,
	getDevelopmentStrategyList,
	getCorporateCultureList,
	getTechnologyPatentList,
	getDevelopmentHistoryList,
	getOrganizationalStructureList,
};

export default API;



// WEBPACK FOOTER //
// ./src/api/gwManage/aboutUs.js